import { render, staticRenderFns } from "./DeclaracaoDePrivacidade.vue?vue&type=template&id=5c71b6c2&scoped=true&"
import script from "./DeclaracaoDePrivacidade.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoDePrivacidade.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoDePrivacidade.vue?vue&type=style&index=0&id=5c71b6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71b6c2",
  null
  
)

export default component.exports